import React, { useState, useEffect } from 'react'
import {
    Button, Dialog, Grid, Icon, Typography, Select, Switch, Radio,
    FormGroup, FormControl, FormHelperText, RadioGroup, FormControlLabel
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import useStyles from "./styles";
import { Label, DraggableComponent } from '../../../../../components/UiElements/UiElements';
import DialogLoader from './../../../../../components/Loader/DialogLoader';
import { withSnackbar } from "./../../../../../components/Message/Alert";
import SearchGrid from '../../../../../components/table/SearchGrid';

function LosView({ dialogOpenClose, handleClose, handleSuccessClose, selectedListId, ...props }) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [lstAgencies, setLstAgencies] = useState([{title:'thiis ksjdhf', createDate:'20/01/1212'}]);
    const isLetterofSupportAgencyDelete = () =>{
       console.log("this is dekecte") 
    }
    useEffect(() => {
    }, []);


    return (
        <>

            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="md"
                PaperComponent={DraggableComponent}
                {...props} >
                <div className={classes.activeDialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>Letter of Support</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>
                        {isLoading ? <DialogLoader></DialogLoader> : ''}


                        <div className={classes.contentSecond}>

                            <SearchGrid
                                columns="losAgencyList"
                                list={lstAgencies}
                                noRecordMsg="No record exists"
                                Icon={true}
                                isLetterofSupportAgencyDelete={isLetterofSupportAgencyDelete}
                                isTopPagination={true}
                            />

                        </div>

                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            </div>
                        </div>

                    </div>
                </div>
            </Dialog >
        </>
    )
}

export default withSnackbar(LosView); 